import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
})
export class HeaderComponent {
  @Input() small = false;
  @Input() big = false;
  @Input() bigish = false;
  @Input() tiny = false;
}
